import chakraTokenToVar from '@/utils/chakraTokenToVar'

const normalStyle = {
  list: {
    bg: 'bg',
    border: `2px solid ${chakraTokenToVar('border.emphasized')}`,
    borderRadius: '8px',
    py: '8px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
  },
  item: {
    py: '8px',
    fontSize: '14px',
    color: 'fg',
    bg: 'bg',
    border: 'none',
    transition: 'background 50ms ease-in 0s',
    _hover: {
      cursor: 'pointer',
    },
    _focus: {
      bg: 'bg.muted',
    },
    _active: {
      bg: 'bg.muted',
    },
    _expanded: {
      bg: 'bg.muted',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },
}

export default {
  variants: {
    notification: {
      list: {
        bg: 'bg',
        color: 'fg',
        minW: '3xs',
        py: '0',
        px: '0',
        zIndex: 1,
        borderRadius: 'md',
        borderWidth: '1px',
      },
      item: {
        py: '0',
        px: '0',
        borderRadius: 'md',
        transition: 'background 50ms ease-in 0s',
        _focus: {
          bg: 'bg.muted',
        },
        _active: {
          bg: 'bg.muted',
        },
        _expanded: {
          bg: 'bg.muted',
        },
        _disabled: {
          opacity: 0.4,
          cursor: 'not-allowed',
        },
      },
    },
    normal: normalStyle,
  },
  baseStyle: normalStyle,
}
